import { Box, TextField } from "@mui/material";
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { ConfirmationDialogResult } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { ILogProperties } from "../../../models/log/logProperties";
import * as logService from "../../../models/services/logService";
import { IUnitNode } from "../../../models/unit/unitNode";
import { IUnitPermissionUserGroup } from "../../../models/userGroup/unitPermissionUserGroup";
import { Dialog } from "../../framework/Dialog/Dialog";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { IPageNavMenuItem } from "../../framework/PageNav/PageNavMenuItems";
import { UnitApplicationPermissionsNew } from "source/components/framework/Unit/UnitApplicationPermissionsNew";

/* eslint-disable no-unused-vars */
export const enum LogSettingsDialogMenuItem {
    LogProperties = "1",
    Permissions = "2",
}
/* eslint-enable no-unused-vars */

export interface ILogPropertiesDialogProp {
    classes?: string;
    companyId: string;
    properties: ILogProperties;
    settingsActions: IPageNavMenuItem[];
    onOk: () => void;
    onCancel: () => void;
}

export interface ILogPropertiesDialogState {
    activeMenuItem: LogSettingsDialogMenuItem;
    isCompanySpecific: boolean;
    logSizeInDaysStr: string;
    userGroups: IUnitPermissionUserGroup[];
    unitNode: IUnitNode;
    saveUnitNode: IUnitNode;
}

export class LogPropertiesDialog extends React.Component<ILogPropertiesDialogProp, ILogPropertiesDialogState> {
    private orgStateHash: string = "";

    constructor(props: ILogPropertiesDialogProp) {
        super(props);
        const properties = props.properties;
        const userGroups = properties.userGroups.slice(0);
        this.state = {
            activeMenuItem: LogSettingsDialogMenuItem.LogProperties,
            isCompanySpecific: props.companyId !== Base.emptyGuid,
            logSizeInDaysStr: properties.logSizeInDays.toString(10),
            userGroups,
            unitNode: properties.unitNode,
            saveUnitNode: properties.unitNode
        };
        const saveData = this.getSaveDataFromState(props, this.state);
        this.orgStateHash = saveData.hash;
        //console.log("this.state", this.state)
    }

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "logSizeInDays") {
            this.setState({ logSizeInDaysStr: value });
        }
    };

    handleBlur = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "logSizeInDays") {
            this.setState({ logSizeInDaysStr: value.toInteger().toString(10) });
        }
    };

    handleChangeSaveUnitNode = (saveUnitNode: IUnitNode) => {
        this.setState({
            saveUnitNode
        });
    };

    getSaveDataFromState = (props: ILogPropertiesDialogProp, state: ILogPropertiesDialogState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("companyId", props.companyId);
        result.append("permissions", state.saveUnitNode.getJsonUnitNodeSaves([], null, null));
        result.append("logSizeInDays", state.logSizeInDaysStr.toInteger());
        return result;
    };

    saveToDb = async () => {
        const obj = this;
        const props = this.props;
        const state = this.state;
        const saveData = obj.getSaveDataFromState(props, state);
        //Call server
        const result = await AppUtils.callService(() => logService.saveLogProperties(saveData.obj));
        if (!result) return;
        props.onOk();
    };

    handleSave = () => {
        this.saveToDb();
    };

    handleCancel = async () => {
        const props = this.props;
        const state = this.state;
        const cancelResult = await AppUtils.cancel(this.getSaveDataFromState(props, state).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.saveToDb();
        } else {
            props.onCancel();
        }
    };

    handleClean = async () => {
        if (this.state.isCompanySpecific) return;
        if (await AppUtils.showConfirmationDialog(Translations.DoYouReallyWantToClearLog) === ConfirmationDialogResult.Yes) {
            await AppUtils.callService(() => logService.clearLog());
        }
    };

    handleToggleActiveMenuItem = async (menuItem: string) => {
        alert(menuItem);
    };

    render() {
        const props = this.props;
        const state = this.state;

        return (
            <Dialog
                id="log-properties-dialog"
                maxWidth={state.isCompanySpecific ? "md" : "sm"}
                maxHeight={state.isCompanySpecific ? "90%" : undefined}
                title={state.isCompanySpecific ? Translations.Permissions : Translations.Settings}
                body={<>
                    {(!state.isCompanySpecific
                        ? <FormField title={Translations.LogSizeInDays} margin="0">
                            <TextField name="logSizeInDays" title={Translations.LogSizeInDays} value={state.logSizeInDaysStr} onChange={this.handleChange} onBlur={this.handleBlur} inputProps={{ maxLength: 5 }}/>
                        </FormField>
                        : <Box height="calc(100% + 16px)">
                            <UnitApplicationPermissionsNew
                                companyId={props.companyId}
                                unitId={state.unitNode?.id}
                                groups={state.userGroups}
                                unitNode={state.unitNode}
                                unitPermissions={props.properties.unitPermissions}
                                cardView={true}
                                onChangeSaveUnitNode={this.handleChangeSaveUnitNode}
                            />
                        </Box>
                    )}
                </>}
                buttons={[
                    { title: Translations.DoCleanLog, variant: "outlined", onClick: !state.isCompanySpecific ? this.handleClean : null },
                    { title: Translations.Close, variant: "outlined", onClick: this.handleCancel },
                    { title: Translations.Save, variant: "confirmation", onClick: this.handleSave },
                ]}
                onClose={this.handleCancel}/>
        );
    }
}